import { render, staticRenderFns } from "./UiStoryVideo.vue?vue&type=template&id=2183a691&lang=pug"
import script from "./UiStoryVideo.vue?vue&type=script&lang=js"
export * from "./UiStoryVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports